import img0 from "../assets/images/img0.jpg";
import img30 from "../assets/images/img30.jpg";
import img2 from "../assets/images/img2.jpg";
import img3 from "../assets/images/img3.jpg";
import img4 from "../assets/images/img4.jpg";
import img5 from "../assets/images/img5.jpg";
import img6 from "../assets/images/img6.jpg";
import img7 from "../assets/images/img7.jpg";
import img8 from "../assets/images/img8.jpg";
import img9 from "../assets/images/img9.jpg";
import img10 from "../assets/images/img10.jpg";
import img11 from "../assets/images/img11.jpg";
import img12 from "../assets/images/img12.jpg";
import img13 from "../assets/images/img13.jpg";
import img14 from "../assets/images/img14.jpg";
import img15 from "../assets/images/img15.jpg";
import img16 from "../assets/images/img16.jpg";
import img17 from "../assets/images/img17.jpg";
import img18 from "../assets/images/img18.jpg";
import img19 from "../assets/images/img19.jpg";
import img20 from "../assets/images/img20.jpg";
import img21 from "../assets/images/img21.jpg";
import img22 from "../assets/images/img22.jpg";
import img23 from "../assets/images/img23.jpg";
import img24 from "../assets/images/img24.jpg";
import img26 from "../assets/images/img26.jpg";

const galleryImages = [
  {
    img: img17,
    alt: "",
  },
  {
    img: img16,
    alt: "",
  },
  {
    img: img26,
    alt: "",
  },
  {
    img: img21,
    alt: "",
  },
  {
    img: img0,
    alt: "",
  },
  {
    img: img10,
    alt: "",
  },
  {
    img: img30,
    alt: "",
  },
  {
    img: img2,
    alt: "",
  },
  {
    img: img5,
    alt: "",
  },
  {
    img: img15,
    alt: "",
  },
  {
    img: img13,
    alt: "",
  },
  {
    img: img3,
    alt: "",
  },
  {
    img: img24,
    alt: "",
  },
  {
    img: img4,
    alt: "",
  },
  {
    img: img6,
    alt: "",
  },
  {
    img: img7,
    alt: "",
  },
  {
    img: img19,
    alt: "",
  },
  {
    img: img9,
    alt: "",
  },
  {
    img: img20,
    alt: "",
  },
  {
    img: img18,
    alt: "",
  },
  {
    img: img8,
    alt: "",
  },
  {
    img: img11,
    alt: "",
  },
  {
    img: img12,
    alt: "",
  },
  {
    img: img14,
    alt: "",
  },
  {
    img: img22,
    alt: "",
  },
  {
    img: img23,
    alt: "",
  },
];

export default galleryImages;
